/** Toggle a value in a multi-select set. Order is not significant for grading. */
export function toggleSet(current: string[], value: string): string[] {
  return current.includes(value) ? current.filter((v) => v !== value) : [...current, value];
}

export function placeTile(slots: Array<string | null>, tile: string): Array<string | null> {
  const next = [...slots];
  const empty = next.findIndex((s) => s == null);
  if (empty === -1) return next;
  next[empty] = tile;
  return next;
}

export function removeSlot(slots: Array<string | null>, index: number): Array<string | null> {
  const next = [...slots];
  if (index < 0 || index >= next.length) return next;
  next[index] = null;
  return next;
}

export function remainingTiles(all: string[], slots: Array<string | null>): string[] {
  const used = new Map<string, number>();
  for (const s of slots) {
    if (s == null) continue;
    used.set(s, (used.get(s) ?? 0) + 1);
  }
  const left: string[] = [];
  const taken = new Map<string, number>();
  for (const tile of all) {
    const n = taken.get(tile) ?? 0;
    if (n < (used.get(tile) ?? 0)) {
      taken.set(tile, n + 1);
      continue;
    }
    left.push(tile);
  }
  return left;
}

export function filledOrder(slots: Array<string | null>): string[] | null {
  if (slots.some((s) => s == null)) return null;
  return slots.map(String);
}

export function emptySlots(count: number): Array<string | null> {
  return Array.from({ length: count }, () => null);
}
